"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var lab_1 = require("@material-ui/lab");
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var fieldsProps_1 = require("./utils/fieldsProps");
var StyledPaper = styled_components_1.default(core_1.Paper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 350px;\n"], ["\n    width: 350px;\n"])));
function TTableSavePreset(props) {
    var registryCode = props.registryCode, allPresets = props.allPresets, tableState = props.tableState, savePreset = props.savePreset, onSavePreset = props.onSavePreset, visibleColumns = props.visibleColumns, isAdmin = props.isAdmin;
    var presets = allPresets.filter(function (preset) { return preset.id !== 'default' && !preset.autoSaved && (isAdmin || !preset.shared); });
    var _a = react_1.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var _b = react_1.useState(null), existedPreset = _b[0], setExistedPreset = _b[1];
    var _c = react_1.useState(''), presetName = _c[0], setPresetName = _c[1];
    var _d = react_1.useState(false), saveExisted = _d[0], setSaveExisted = _d[1];
    var _e = react_1.useState(false), startValidation = _e[0], setStartValidation = _e[1];
    var isValidPreset = saveExisted || presetName;
    var handleTogglePopover = react_1.useCallback(function (event) {
        if (anchorEl) {
            setAnchorEl(null);
        }
        else {
            setPresetName('');
            setStartValidation(false);
            setSaveExisted(false);
            setAnchorEl(event.currentTarget);
        }
    }, [setPresetName, setAnchorEl, anchorEl]);
    var handleClosePopover = react_1.useCallback(function () {
        setAnchorEl(null);
    }, [setAnchorEl]);
    var handleChangePresetName = react_1.useCallback(function (event) {
        setPresetName(event.target.value);
    }, [setPresetName]);
    var handleChangeSaveCurrent = react_1.useCallback(function (event, checked) {
        setSaveExisted(checked);
        setExistedPreset(null);
        return checked;
    }, [setSaveExisted]);
    var handleSave = react_1.useCallback(function () {
        var visibleColumnsIdList = visibleColumns.map(function (column) { return column.id; });
        setStartValidation(true);
        if (isValidPreset) {
            var presetData = __assign(__assign({}, tableState), { hiddenColumns: [], visibleColumns: visibleColumnsIdList });
            var preset = saveExisted && existedPreset
                ? __assign(__assign({}, existedPreset), { data: presetData }) : {
                title: presetName,
                data: presetData,
                autoSaved: false,
                registryCode: registryCode,
                shared: false,
                default: false,
                sharedRules: [],
            };
            savePreset(preset)
                .then(onSavePreset)
                .then(function () { return setAnchorEl(null); });
        }
    }, [existedPreset, onSavePreset, presetName, saveExisted, savePreset, registryCode, tableState, isValidPreset]);
    var handleChangePreset = react_1.useCallback(function (event, value) {
        setExistedPreset(value);
    }, [setExistedPreset]);
    var getOptionLabel = react_1.useCallback(function (p) { return p.title; }, []);
    var getOptionSelected = react_1.useCallback(function (o, v) { return o.id === v.id; }, []);
    var renderInput = react_1.useCallback(function (params) { return react_1.default.createElement(core_1.TextField, __assign({}, params, fieldsProps_1.textFieldProps)); }, []);
    var renderOption = react_1.useCallback(function (p) { return p.title; }, []);
    var comparePresets = react_1.useCallback(function (presetA, presetB) {
        return presetA.shared === presetB.shared ? 0 : presetA.shared ? 1 : -1;
    }, []);
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Link, { onClick: handleTogglePopover },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.savePreset", defaultMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043F\u0440\u0435\u0441\u0435\u0442" })),
        react_1.default.createElement(core_1.Popover, { open: open, anchorEl: anchorEl, onClose: handleClosePopover, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            } },
            react_1.default.createElement(StyledPaper, null,
                react_1.default.createElement(core_1.Box, { p: 3 },
                    react_1.default.createElement(core_1.TextField, __assign({ label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.presetName", defaultMessage: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u0435\u0441\u0435\u0442\u0430" }), placeholder: intl.formatMessage({
                            id: 'ttable.placeholderPresetName',
                            defaultMessage: 'Введите название пресета',
                        }), disabled: saveExisted, value: saveExisted ? existedPreset === null || existedPreset === void 0 ? void 0 : existedPreset.title : presetName, onChange: handleChangePresetName, required: true, error: startValidation && !isValidPreset }, fieldsProps_1.textFieldProps)),
                    !!presets.length && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.FormControlLabel, { value: "top", control: react_1.default.createElement(core_1.Checkbox, { color: "primary", value: saveExisted, onChange: handleChangeSaveCurrent }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.changeExistedPreset", defaultMessage: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439" }), labelPlacement: "end" }),
                        saveExisted && (react_1.default.createElement(lab_1.Autocomplete, { disableClearable: true, popupIcon: react_1.default.createElement(ExpandMore_1.default, null), noOptionsText: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.resultsOption", defaultMessage: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }), ChipProps: {
                                deleteIcon: react_1.default.createElement(icons_1.Clear, null),
                                size: 'small',
                            }, clearText: "", closeText: "", openText: "", value: existedPreset || undefined, options: presets.sort(comparePresets), onChange: handleChangePreset, getOptionLabel: getOptionLabel, getOptionSelected: getOptionSelected, renderOption: renderOption, renderInput: renderInput }))))),
                react_1.default.createElement(core_1.Divider, null),
                react_1.default.createElement(core_1.Box, { p: 3 },
                    react_1.default.createElement(core_1.Grid, { container: true, item: true, justify: "center" },
                        react_1.default.createElement(core_1.Link, { onClick: handleSave },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.save", defaultMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }))))))));
}
exports.default = TTableSavePreset;
var templateObject_1;
